import * as yup from "yup";
import constantes from "../../catalogos/constantes";
const incidenciaValidacionEsquema = yup.object().shape({
    solicitante: yup.mixed().required(),   
    prioridadId: yup.mixed().required(),      
    departamentoId: yup.mixed().required(),         
    tipoId:yup.mixed().required(),   
    subTipoId:yup.mixed().required(),   
    descripcion:yup.mixed().required(),   
    ubicacionId: yup.mixed().required(),   
    tipoEmpleadoId: yup.mixed().required(),   
    unidadId: yup.mixed().when("puestoId", {
        is: (val) => val === constantes.puestos.operador,
        then: yup.mixed().required(),
        otherwise: yup.mixed().nullable(),
    }),   
    operadorId: yup.mixed().required(),   
    atendio:yup.mixed().required(),   
    fechaIncidencia:yup.mixed().required(),   
    horaIncidencia:yup.mixed().required(),   
    latitud: yup.mixed().when("departamentoId", {
        is: (val) => val === constantes.departamento.MonitoreoSeguridad,
        then: yup.mixed().required(),
        otherwise: yup.mixed().nullable(),
    }),
    longitud: yup.mixed().when("departamentoId", {
        is: (val) => val === constantes.departamento.MonitoreoSeguridad,
        then: yup.mixed().required(),
        otherwise: yup.mixed().nullable(),
    }),
    tieneReporteAseguradora: yup.boolean().required(),
    reporteAseguradora: yup.mixed().when('tieneReporteAseguradora', {
            is: true,
            then: yup.mixed().required()
        }),
});

export default incidenciaValidacionEsquema;
